import React, { useState } from "react";
import HmiViewModal, { ViewHmi } from "../HmiView/HmiViewModal";
import PremierPlusFanSettingsModal from "../PremierPlusFanSettingsModal";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import NoticeCardSectionCore from "./NoticeCardSectionCore";
import PremierPlusDryerSettingsModalV2 from "../PremierPlusDryerSettingsModalV2";

interface NoticeCardSectionProps {
  binDto: PremierPlusBinDTO | null;
}

const NoticeCardSection = ({ binDto }: NoticeCardSectionProps) => {

    const [showFanSettingsModal, setShowFanSettingsModal] = useState(false);
    const [showDryerSettingsModal, setShowDryerSettingsModal] = useState(false);
    const [showHmi, setShowHmi] = useState<ViewHmi | null>(null);

    const handleShowFanSettingsModal = () => setShowFanSettingsModal(true);
    const handleCloseFanSettingsModal = () => setShowFanSettingsModal(false);

    const handleShowDryerSettingsModal = () => setShowDryerSettingsModal(true);
    const handleCloseDryerSettingsModal = () => setShowDryerSettingsModal(false);

    const handleClickViewDrying = () => {
        setShowHmi(ViewHmi.Dry);
    }

    const handleClickViewGrainMoving = () =>{
        setShowHmi(ViewHmi.MoveGrain);
    }
    
    const handleClickViewFan = () => {
        setShowHmi(ViewHmi.Fan);
    }
    
    const handleClickViewMoveGrain = () => {
        setShowHmi(ViewHmi.MoveGrain);
    }
    
    const handleCloseHmi = () => {
        setShowHmi(null);
    }
  
    return(
        <>
            <NoticeCardSectionCore 
            binDto={binDto}
            handleShowFanSettingsModal={handleShowFanSettingsModal} 
            handleShowDryerSettingsModal={handleShowDryerSettingsModal} 
            handleClickViewDrying={handleClickViewDrying}     
            handleClickViewFan={handleClickViewFan}   
            handleClickViewGrainMoving={handleClickViewGrainMoving}    
            />
            
            <PremierPlusFanSettingsModal
            open={showFanSettingsModal}
            onClose={handleCloseFanSettingsModal}
            onCancel={handleCloseFanSettingsModal}
            centered
            destroyOnClose
            binDto={binDto}
            />

            <PremierPlusDryerSettingsModalV2
            open={showDryerSettingsModal}
            onClose={handleCloseDryerSettingsModal}
            onCancel={handleCloseDryerSettingsModal}
            centered
            destroyOnClose
            binDto={binDto}
            />
        
            <HmiViewModal 
            open={showHmi != null} 
            binDto={binDto} 
            onClose={handleCloseHmi}
            onCancel={handleCloseHmi}
            view={showHmi}
            />
        </>
    )
}

export default NoticeCardSection;